module.exports = __FOREMAN_VENDOR__PATTERNFLY_REACT_EXTENSIONS__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__PATTERNFLY_REACT_EXTENSIONS__"
// module id = patternfly-react-extensions
// module chunks = 0 1 2